import { filter,set, trim, findIndex } from 'lodash'
import { http, queryString } from 'utils'

// User mutation imports.
import { SET_PROPERTY, SET_SLAS, SET_SLA, ADD_SLA, ADD_SCHEDULE, RESET_SLA } from 'vx/mutations'

const initialSLAState = () => {
  return {
    id: null,
    client_id: null,
    contact_firstname: "",
    contact_surname: "",
    type_id: null,
    monthly_hours: 0,
    start_date: "",
    end_date: "",
    override_rate: 185,
    create_proposal: false,
    contact_email: "",
    current_schedule: {
        id: null,
        sla_id: null,
        remaining: 0,
        month: 0,
        rollover: 0
    },
    schedule: []
  }
}

// User state.
const state = {
  authorized: false,
  sla: initialSLAState(),
  slas: []
}

// User state getters.
const getters = {
  /**
   * Active SLAs
   */
  activeSLAs: state => filter(state.slas, (sla) => { return sla.status == 'active' }),

  /**
   * Awaiting acceptance slas
   */
  waitingAcceptanceSLAs: state => filter(state.slas, (sla) => { return sla.status == 'awaiting acceptance' }),

  uri (state, rootGetters) {
      return (path) => {
          let uri = "slas"

          // When references parent modules we pass the ":id" helper so we can set the path
          // to the loaded resources ID. This lets us generate URIs for nested modules.
          if (path === ':id') {
              path = state.sla.id
          }

          if (path !== undefined) {
              uri = `${uri}/${trim(path, '/')}`
          }

          return uri
      }
  }
}

// User actions.
const actions = {

  /**
   * Get a list of slas.
   */
  getSLAs ({ commit }, payload) {
    return http.get(`slas?${queryString(payload)}`).then(response => {
      commit(SET_SLAS, response.data.data)

      return response
    })
  },

  /**
   * Get a specific sla.
   */
  getSLA ({ commit }, {id, payload}) {
    return http.get(`slas/${id}?${queryString(payload)}`).then(response => {
      commit(SET_SLA, response.data.data)

      return response
    })
  },

  addSLA({ commit, getters }, payload) {
    return http.post('/slas', payload).then(response => {
      commit(ADD_SLA, response.data.sla)

      return response
    })
  },

  updateSLA({ commit, getters }, { id, payload }) {
    return http.put(`/slas/${id}`, payload).then(response => {
      commit(ADD_SLA, response.data)
      commit(SET_SLA, response.data)

      return response
    })
  },

  updateSLATimesMistmatch({ commit }, { id, payload }) {
    return http.put(`slas/${id}/times`, payload).then(response => {
      commit(ADD_SCHEDULE, response.data.schedule)

      return response
    })
  },

  completeSLA({ commit, getters }, { id, payload }) {
    return http.put(`/slas/${id}/complete`, payload).then(response => {
      commit(ADD_SLA, response.data)
      commit(SET_SLA, response.data)

      return response
    })
  },

  sendUsageReport({ commit }, { slaId, scheduleId }) {
    return http.post(`/slas/${slaId}/schedules/${scheduleId}/usage-report/send`)
  },

  setSLAProperty({ commit }, payload) {
    commit(SET_PROPERTY, payload)
  },

}

// User state mutations.
const mutations = {

  [SET_SLA] (state, sla) {
    state.sla = sla
  },

  [SET_SLAS] (state, slas) {
    state.slas = slas
  },

  [ADD_SLA] (state, sla) {
    let existingSLA = findIndex(state.slas, existing => existing.id === sla.id)

    if (existingSLA === -1) {
      state.slas.push(sla)
    } else {
      state.slas.splice(existingSLA, 1, sla)
    }
  },

  [ADD_SCHEDULE] (state, insertSchedule) {
    let existingSchedule = findIndex(state.sla.schedule, existing => existing.id === insertSchedule.id)

    if (existingSchedule === -1) {
      state.sla.schedule.push(sla)
    } else {
      state.sla.schedule.splice(existingSchedule, 1, insertSchedule)
    }
  },

  [RESET_SLA] (state) {
    state.sla = initialSLAState()
  },

  [SET_PROPERTY] (state, { property, value }) {
    set(state.sla, property, value)
  }
}

// Export our state, getters, actions, mutations, and modules.
export default {
  namespaced: true, state, getters, actions, mutations
}
